<template>
  <div ref="layout" class="page-form">
    <h3 class="title">产品信息修改</h3>

    <div v-if="productData" class="form-container">
      <div class="tools" style="margin-bottom: 10px">
        <form-button name="返回" @click="$router.go(-1)" />
        <form-button name="保存" type="primary" @click="saveData" />
      </div>
      <collapse-query2 title="基本信息">
        <base-info ref="base" :prod="productData" />
      </collapse-query2>
      <collapse-query2 title="计划属性">
        <plan-attr ref="plan" :prod="productData" />
      </collapse-query2>
      <collapse-query2 title="配额信息">
        <quota-info ref="quota" :prod="productData" />
      </collapse-query2>
      <collapse-query2 title="附加信息">
        <attach-info ref="attach" :prod="productData" />
      </collapse-query2>
    </div>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo.vue'
import PlanAttr from './components/PlanAttr.vue'
import QuotaInfo from './components/QuotaInfo.vue'
import AttachInfo from './components/AttachInfo.vue'

import { saveProduct, apiProductDetail } from '@/api/sap/client-sap'
export default {
  components: {
    AttachInfo,
    QuotaInfo,
    PlanAttr,
    BaseInfo
  },
  data() {
    return {
      productData: null
    }
  },
  created() {
    this.getInfo(this.$route.query.id)
  },
  methods: {
    async getInfo(product_id) {
      const { data } = await apiProductDetail({ product_id })
      this.productData = {
        ...data.head,
        history: data.history,
        yxdy: data.yxdy
      }
      // this.productData = JSON.parse(window.localStorage.getItem('wly-product-data'))
    },
    async saveData() {
      const baseInfo = this.$refs.base.submitForm()
      const planInfo = this.$refs.plan.submitForm()
      const quotaInfo = this.$refs.quota.submitForm()
      const attachInfo = this.$refs.attach.submitForm()
      const params = JSON.parse(JSON.stringify(this.productData))
      Object.assign(params, baseInfo.base, planInfo, quotaInfo, attachInfo)

      const res = await saveProduct({
        model: 'M',
        partner: this.$store.getters.role.USER_BP,
        Data5: params,
        Data6: baseInfo.saleCenter
      })
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        if (res.msgs.length) {
          res.msgs.forEach(v => {
            this.$message.warning(v.message)
          })
        }
      } else {
        this.$message.warning(res.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding: 0 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/product-manage/productEdit.vue